import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const NotificationStatePopup = ({
  absolute = true,
  buttons = null,
  buttonsClassName = '',
  children,
  className,
  header,
  isNotFound,
  message = '',
  title = '',
}) => {
  const NotificationPopupClass = cx(
    'notification-state-popup',
    { 'with-button': buttons },
    className,
  );
  const calculatedButtonsClassName = cx(
    'sticky-bottom-buttons-container double',
    buttonsClassName,
    { absolute },
  );

  const textClassName = cx('notification-text', {
    'not-found': isNotFound,
  });

  return (
    <div className={NotificationPopupClass}>
      {header}
      <div className={textClassName}>
        <Label className="title-text" message={title} />
        {message && <Label className="sub-title-text" message={message} />}
      </div>
      {children}
      {buttons && <div className={calculatedButtonsClassName}>{buttons}</div>}
    </div>
  );
};

NotificationStatePopup.propTypes = {
  buttons: PropTypes.node,
  buttonsClassName: PropTypes.string,
  message: PropTypes.string,
  title: PropTypes.string,
};

export default NotificationStatePopup;
